import { Injectable } from '@angular/core';
import { CredentialsService } from '@app/auth';

import { environment } from '@env/environment';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { GeneralService } from '../general.service';
import { HttpService } from '../http.service';
import { Logger } from '@app/@shared/logger.service';

const log = new Logger('nuvei-service');

@Injectable({
  providedIn: 'root',
})
export class MailServiceService {
  constructor(private credentialsS: CredentialsService, private httpS: HttpService) {}

  //d-7c931531f5b140f58560bf83900bb8ac

  async sendMail(template: string, body: any, mail: string): Promise<any> {
    let to: string = '';
    if (mail === '') {
      to = this.credentialsS.credentials?.email as string;
    } else {
      to = mail;
    }
    try {
      const url = environment.api.mailSend.url;
      const data = await this.httpS.post(url, {
        to,
        //to: 'tcaldino@emt.dev',
        templateId: template,
        dynamicTemplateData: body,
      });

      log.info('Mail sent successfully', { to, templateId: template, body, data });

      if (data) {
        return data;
      }
    } catch (error) {
      log.error(error);
    }

    return null;
  }
}
